import { Button, Typography, Modal, Icon } from '@safedns/skydns-ui-react-lib';

import { useGetUserQuery, useDeleteAgentMutation } from '../../services/ADapi';

import sprite from '../../icons/sprite.svg';
import styles from '../../styles/deleteModal.module.scss';

const DeleteAgentModal = ({ uid, agentName, onClose }) => {
  const {
    data: { user_id },
  } = useGetUserQuery();
  const [deleteAgent, { isLoading }] = useDeleteAgentMutation();

  const deleteAgentModal = async () => {
    try {
      await deleteAgent({ user_id, uid });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      isOpen={true}
      title="Удалить агент?"
      onClose={onClose}
      sx={{ maxWidth: 460 }}
    >
      <div className={styles['modal-content']}>
        <div className={styles['icon-wrapper']}>
          <Icon
            id="remove"
            sprite={sprite}
            width={24}
            height={24}
            color="white"
          />
        </div>
        <Typography
          sx={{
            paddingTop: 12,
            paddingBottom: 24,
            textAlign: 'center',
            fontWeight: 500,
          }}
        >
          Вы уверены что хотите удалить <br /> {agentName}?
        </Typography>
        <div className="button-grid">
          <Button variant="secondary" onClick={onClose} size="small">
            Отмена
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={deleteAgentModal}
            isDisabled={isLoading}
          >
            Удалить
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAgentModal;
